export default "__VITE_ASSET__DVIaiySO__"